<template>
    <div class="page8">
        <video
        src="/videos/industry.MP4"
        muted
        ref="Video"
        ></video>
    </div>
</template>
<script>
import { sleep } from "@/utils/utils.js";

export default {
    data: function() {
        return {
        }
    },
    methods: {
        async playPageStart() {
            await this.page7Fn();
            this.$emit("playEnd");
        },
        async page7Fn() {
            this.$refs.Video.play();
            await sleep(1000);
            this.$refs.Video.pause();
            await sleep(1000);
            this.$refs.Video.play();
            await sleep(2000);
        },
    },
}
</script>
<style lang="less" scoped>
.page8 {
    width: 100%;
    height: 100%;
    video {
        width: 100%;
    }
}
</style>
